// Keep these pages temporarily unavailable while retaining their implementations.
export const TEMPORARILY_HIDDEN_PATHS = [
  "/search",
  "/orders/:id/search",
  "/agent",
  "/modules",
  "/settings/modules",
];

export const isPageVisible = (path) => !TEMPORARILY_HIDDEN_PATHS.includes(path);
